import { observable, action, autorun } from 'mobx';
import { FEATURE_LIST } from '~/constants/featuresList';
import { setNewItem, getItem, removeItem } from '~/services/localStorage';

class FeaturesListStore {
  @observable layout;
  @observable features;
  
  constructor({layout, features}) {
    this.layout = layout;
    this.features = features;
  }

  getFeatureById = (id) => {
    return this.features.slice().find(feature => feature.id === id);
  }

  getResetValue(key){
    const resetValues = {
      'isOpen': true,
      'size': 0,
      'selectedId': null,
      'isToggleOn': false,
      'fontId': null
    };
    return resetValues[key];
  }

  @action resetFeatures = () => {
    for (const feature of this.features.slice()){
      for (const key in feature.options) {
        const resetValue = this.getResetValue(key);
        feature.options[key] = resetValue;
      }
    }
  }

  @action setFeatureOptions = (id, options = {}) => {
    const feature = this.getFeatureById(id)
    if (feature) {
      for (const key in options){
        feature.options[key] = options[key];
      }
    }
  }

  @action openFeature = (id) => {
    const feature = this.getFeatureById(id)
    if (feature) {
      feature.options.isOpen = !feature.options.isOpen;
    }
  }

  @action setLayout = (layout) => {
    this.layout = layout;
  }
}

const storeData = getItem('billyFeaturesListStore') || FEATURE_LIST;
const featuresListStore = new FeaturesListStore(storeData);

autorun(() => {
  setNewItem('billyFeaturesListStore', {
    layout: featuresListStore.layout,
    features: featuresListStore.features
  })
})

export default featuresListStore;
export { FeaturesListStore };


// WEBPACK FOOTER //
// ./src/stores/featuresListStore/index.js